import { setupI18n } from '@lingui/core'
import memoize from 'fast-memoize'

import LOCALE_CATALOGS from 'shared/consts/localeCatalogs'
import missingTranslationHandler from 'views/enhancers/withIntlProvider/missingTranslationHandler'

const createI18n = (
  locale: string,
  missingHandler?: string | ((language: string, id: string) => string) // type copied from setupI18nProps
) => {
  if (!locale) {
    throw new Error('please provide a locale')
  }
  return setupI18n({
    language: locale,
    catalogs: LOCALE_CATALOGS,
    missing: missingHandler ? missingHandler : missingTranslationHandler,
  })
}

const getI18n = memoize(createI18n)

export default getI18n
